import React from 'react';
import {
  Modal,
  CustomModalLayout,
  Cell,
  Layout,
  Card,
  Box,
  Badge,
  Text,
  Image,
  Heading
} from '@wix/design-system';

class WhoIsContent extends React.Component {

    render() {
        return(
          <Modal
            isOpen={this.props.whoisPage}
            onRequestClose={() => this.props.contentOverlay('whoisPage', false)}
            shouldCloseOnOverlayClick
            screen="desktop"
          >
            <CustomModalLayout
              secondaryButtonText={I18n.t('installguide.close_modal')}
              secondaryButtonOnClick={() => this.props.contentOverlay('whoisPage', false)}
              onCloseButtonClick={() => this.props.contentOverlay('whoisPage', false)}
              title={I18n.t('whoiscontent.titleSlide')}
              content={
                <Layout cols={12}>
                  <Cell span={12}>
                    <Layout cols={12}>
                      <Cell span={4}>
                        <Box height="18px" marginTop={2} marginLeft={-1}>
                          <Badge size="small" skin="standard">
                            ToM
                          </Badge>
                        </Box>
                        <Card stretchVertically>
                          <Card.Content>
                            <Box marginBottom="12px">
                              <Image src="https://cdn.prod.website-files.com/64a7e3393036f38e45a4c0cc/69a9a0d41c7060273f88be6f_tom.webp" width="226" transparent />
                            </Box>
                            <Box marginBottom="12px">
                              <Heading size="medium">{I18n.t('whoiscontent.tom_title')}</Heading>
                            </Box>
                            <Box marginBottom="12px">
                              <Text>{I18n.t('whoiscontent.tom_text')}</Text>
                            </Box >
                          </Card.Content>
                        </Card>
                      </Cell>
                      <Cell span={4}>
                        <Box height="18px" marginTop={2} marginLeft={-1}>
                          <Badge size="small" skin="standard">
                            Antoine
                          </Badge>
                        </Box>
                        <Card stretchVertically>
                          <Card.Content>
                            <Box marginBottom="12px">
                              <Image src="https://cdn.prod.website-files.com/64a7e3393036f38e45a4c0cc/69a9a103f82fafebb598745a_antone.webp" width="226" transparent />
                            </Box>
                            <Box marginBottom="12px">
                              <Heading size="medium">{I18n.t('whoiscontent.antone_title')}</Heading>
                            </Box>
                            <Box marginBottom="12px">
                              <Text>{I18n.t('whoiscontent.antone_text')}</Text>
                            </Box >
                          </Card.Content>
                        </Card>
                      </Cell>
                      <Cell span={4}>
                        <Box height="18px" marginTop={2} marginLeft={-1}>
                          <Badge size="small" skin="standard">
                            JoJo
                          </Badge>
                        </Box>
                        <Card stretchVertically>
                          <Card.Content>
                            <Box marginBottom="12px">
                              <Image src="https://cdn.prod.website-files.com/64a7e3393036f38e45a4c0cc/69a9a12b3b9b5f2fe9d0cbf9_jojo.webp" width="226" transparent />
                            </Box>
                            <Box marginBottom="12px">
                              <Heading size="medium">{I18n.t('whoiscontent.jojo_title')}</Heading>
                            </Box>
                            <Box marginBottom="12px">
                              <Text>{I18n.t('whoiscontent.jojo_text')}</Text>
                            </Box >
                          </Card.Content>
                        </Card>
                      </Cell>
                      {/* <Cell span={4}>
                        <Box height="18px" marginTop={2} marginLeft={-1}>
                          <Badge size="small" skin="standard">
                            Alex
                          </Badge>
                        </Box>
                        <Card stretchVertically>
                          <Card.Content>
                            <Box marginBottom="12px">
                              <Image src="https://cdn.prod.website-files.com/64a7e3393036f38e45a4c0cc/69a9b14dca40e71f99069a5e_Alex.webp" width="226" transparent />
                            </Box>
                            <Box marginBottom="12px">
                              <Heading size="medium">{I18n.t('whoiscontent.alex_title')}</Heading>
                            </Box>
                            <Box marginBottom="12px">
                              <Text>{I18n.t('whoiscontent.alex_text')}</Text>
                            </Box >
                          </Card.Content>
                        </Card>
                      </Cell> */}
                    </Layout>
                  </Cell>
                </Layout>
              }
            />
          </Modal>
        )
    }
}

export default WhoIsContent
